"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const library_airtable_cms_text_1 = __importStar(require("@talus-analytics/library.airtable.cms-text"));
const library_airtable_cms_icon_1 = __importStar(require("@talus-analytics/library.airtable.cms-icon"));
const library_airtable_cms_image_1 = __importStar(require("@talus-analytics/library.airtable.cms-image"));
const library_airtable_cms_rich_text_1 = __importStar(require("@talus-analytics/library.airtable.cms-rich-text"));
const library_airtable_cms_plot_icon_1 = __importDefault(require("@talus-analytics/library.airtable.cms-plot-icon"));
const library_airtable_cms_download_1 = __importStar(require("@talus-analytics/library.airtable.cms-download"));
const library_airtable_cms_seo_1 = __importStar(require("@talus-analytics/library.airtable.cms-seo"));
const CMS = {
    // components
    Image: library_airtable_cms_image_1.default,
    Text: library_airtable_cms_text_1.default,
    RichText: library_airtable_cms_rich_text_1.default,
    Icon: library_airtable_cms_icon_1.default,
    PlotIcon: library_airtable_cms_plot_icon_1.default,
    Download: library_airtable_cms_download_1.default,
    SEO: library_airtable_cms_seo_1.default,
    // non-AirtableCMSData components
    RenderRichText: library_airtable_cms_rich_text_1.RenderCMSRichText,
    // getters
    getImage: library_airtable_cms_image_1.getCMSImage,
    getText: library_airtable_cms_text_1.getCMSText,
    getDownloadInfo: library_airtable_cms_download_1.getCMSDownloadInfo,
    // hooks
    useIcon: library_airtable_cms_icon_1.useCMSIcon,
    // utilities
    parseRichText: library_airtable_cms_rich_text_1.parseCMSRichText,
    // contexts
    IconProvider: library_airtable_cms_icon_1.CMSIconProvider,
    SiteMetadataProvider: library_airtable_cms_seo_1.SiteMetadataProvider,
    SiteMetadataContext: library_airtable_cms_seo_1.SiteMetadataContext,
};
exports.default = CMS;
//# sourceMappingURL=index.js.map